import {
  parseAccountNumberFinland,
  validateBankgiroSweden,
  validateOcrSweden,
  validatePlusgiroSweden,
} from "@stacc/bank-validation";
import { Country } from "../../../types/common";
import { containsLetters } from "../../../utils/containsLetters";

const isValidFinnishIban = (accountNumber: string): boolean => {
  try {
    parseAccountNumberFinland(accountNumber);
    return true;
  } catch {
    return false;
  }
};

export function validateOnBlur(
  key: string,
  e: React.FocusEvent<HTMLInputElement>,
  setErrorMessages: React.Dispatch<React.SetStateAction<string>>,
  country?: Country,
) {
  let value: string | number = e.target.value;
  switch (key) {
    case "amount":
      if (containsLetters(value)) {
        setErrorMessages(`Illegal characters in ${value}.`);
      } else {
        setErrorMessages("");
      }
      // Replace comma with dot, before parsing to float and rounding up to 2 decimals. E.g: 12,178 => 12.18
      value = Number(Number.parseFloat(value.replace(",", ".")).toFixed(2));
      break;
    case "paymentReference":
      // OCR is a Swedish reference format; the backend skips this check for Finland, so
      // validating it here would block completion on a reference Finland accepts.
      if (
        country === Country.SE &&
        value &&
        !validateOcrSweden(value.toString())
      ) {
        setErrorMessages("Invalid payment reference number");
        return;
      }
      setErrorMessages("");
      break;
    case "accountNumber":
      if (
        value &&
        (country === Country.FI
          ? !isValidFinnishIban(value.toString())
          : !validateBankgiroSweden(value.toString()) &&
          !validatePlusgiroSweden(value.toString()))
      ) {
        setErrorMessages("Invalid account number");
        return;
      }
      setErrorMessages("");
      break;
    default:
      break;
  }
  return value;
}
